<template>
    <div style="
      height: 28rem;
  ">
        <div class="w-full">
            <div class="P-5 pl-1" v-if="!showList && !isImporting">
                <h3 class="text-lg leading-6 font-medium text-gray-900">
                    Connect to NGP VAN
                </h3>
                <div class="text-sm text-gray-600 list-inside list-decimal pt-3">
                    Before importing your list, you'll need to share your Application Name and NGP VAN API
                    key with us.
                </div>
                <div class="text-sm text-gray-600 list-inside list-decimal">
                    <br />
                    <div>
                        <div class="text-black pb-1 font-medium">Application Name</div>
                        <div class="pt-2 pb-1">
                            <input class="form-field-no-icon pr-5 w-full" id="username" v-model="NgpVanUsername"
                                autocomplete="off" />
                        </div>
                        <div class="text-black pt-2 pb-1 font-medium">API Key</div>
                        <div class="pt-2 pb-1">
                            <input class="form-field-no-icon pr-5 w-full" id="apikey" v-model="NgpVanAPIkey"
                                autocomplete="off" />
                        </div>
                    </div>
                </div>
            </div>
            <div v-else-if="showList && !isImporting" style="
      min-height: 25rem;">
                <h2 class="text-lg leading-6 font-medium text-gray-900 pb-2">
                    Choose list to import emails from NGP VAN
                </h2>
                <div class="h-64 mt-7 overflow-auto overflow-x-hidden scroll-style w-full" @scroll="handleScroll"
                    ref="scrollContainer">
                    <table class="w-full">
                        <tbody>
                            <tr class="border-b" v-for="(list, list_id) in NgpVanList" :key="list_id">
                                <td class="px-6 py-3 whitespace-nowrap text-sm font-medium text-gray-900 max-w-sm truncate">
                                    <input type="radio" :checked="selection" :id="list.list_id" :name="list.name"
                                        @change="onSelectList($event)" :value="list.list_id" />
                                    <span class="text-sm text-black px-6 py-3 text-center max-w-sm truncate"
                                        :for="list.list_id">{{
                                        list.name }}</span>
                                </td>
                            </tr>
                            <tr v-if="this.islistloading">
                                <span class="text-sm  px-6 py-3 text-center text-gray-500">Loading...</span>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div v-if="isImporting" class="w-full mt-4 px-1">
                <h3 class="text-lg leading-6 font-medium text-gray-900 mb-2">
                    Importing Email List
                </h3>
                <div class="w-full bg-red-100 rounded-full h-6">
                    <div class="bg-red-500 h-5 text-xs font-medium text-red-100 text-center p-1 leading-none rounded-full transition-all duration-200"
                        :style="{ width: progress + '%' }">
                        {{ progress }}%
                    </div>
                </div>
                <p class="text-sm text-gray-600 mt-2 text-center">
                    Please wait, the Import is in progress...
                </p>
            </div>
        </div>

        <div class="absolute right-5 bottom-5 flex p-3" v-if="!showList">
            <button @click="closeUpload()" class="button-cancel sm:ml-3">
                Cancel
            </button>
            <button @click="submitApiKey()" class="button-submit sm:ml-3">Submit</button>
        </div>
        <div v-else class="absolute right-5 bottom-5 flex p-3">
            <button @click="removeNgpVan" class="button-cancel sm:ml-3">
                Remove NGP VAN
            </button>
            <button @click="ImportNgpVan" type="button" class="button-submit sm:ml-3">
                Import List
            </button>
        </div>
    </div>

</template>

<script>
import { ref } from "vue";
import eventBus from "@/utils/eventBus";
import useConfirmationModal from "@/api/confirmationModal";

export default {
    name: "NgpVanIntegration",
    setup() {
        const radioButton = ref(false);
        const radioButtons = [];
        const isNgpVanAccess = ref(false);
        const NgpVanUsername = ref("");
        const NgpVanAPIkey = ref("");
        const showList = ref(false);
        const NgpVanList = ref([]);
        const NgpVanIdImport = ref("");
        const NgpVanImportListName = ref("");
        const isLoading = ref(false);
        const listCursor = ref(null);
        const islistloading = ref(false);
        const isImporting = ref(false);
        const progress = ref(null);
        const progressTimer = ref(null);
        const selection = ref(false);
        return {
            radioButtons,
            radioButton,
            isNgpVanAccess,
            NgpVanUsername,
            NgpVanAPIkey,
            NgpVanList,
            showList,
            NgpVanIdImport,
            NgpVanImportListName,
            isLoading,
            listCursor,
            islistloading,
            isImporting,
            progress,
            progressTimer,
            selection
        };
    },
    mounted() {
        this.callNgpVanList()
    },
    methods: {
        handleScroll() {
            const container = this.$refs.scrollContainer;
            const bottomThreshold = 50;
            const isNearBottom =
                container.scrollTop + container.clientHeight >= container.scrollHeight - bottomThreshold;
            if (isNearBottom && !this.islistloading) {
                this.scrollNgpVanList();
            }
        },
        async callNgpVanList() {
            try {
                const response = await this.$alfredService.getNgpVanList();
                this.getNgpVanData(response)
                this.NgpVanList = response.data.map(item => ({
                    list_id: item.list_id,
                    name: item.list_name,
                }));
                this.showList = true;
            } catch (e) {
                await this.$alfredService.ngpVanAPIKeyDelete();
                this.isNgpVanAccess = false;
            }
        },
        async getNgpVanData(data) {
            if (data.next != null) {
                let nextUrl = data.next
                this.listCursor = nextUrl;
            }
            else {
                this.listCursor = null
            }
        },
        async scrollNgpVanList() {
            if (this.listCursor == null || this.islistloading) return;
            this.islistloading = true;
            try {
                const data = await this.$alfredService.getNgpVanList(this.listCursor);
                this.getNgpVanData(data);
                let newList = data.data.map(item => ({
                    list_id: item.list_id,
                    name: item.list_name,
                })).filter(newItem =>
                    !this.NgpVanList.some(existingItem => existingItem.list_id === newItem.list_id)
                );
                this.NgpVanList = [...this.NgpVanList, ...newList];
            }
             catch (err) {
                console.error(err);
            }
            finally {
                this.islistloading = false;
            }
        },
        onSelectList(event) {
            this.radioButton = document.getElementById(event.target.id);
            this.radioButtons.push(this.radioButton);
            if (this.radioButtons.length > 0) {
                this.radioButtons.forEach((item) => {
                    if (item.checked) {
                        item.checked = false;
                    }
                });
            }
            this.radioButton.checked = true;
            this.NgpVanIdImport = event.target.id;
            this.NgpVanImportListName = event.target.name;
        },
        closeUpload() {
            this.$emit('NgpVanImport', true);
            this.$emit('NgpVan-clicked', false);
        },
        async submitApiKey() {
            if (!this.NgpVanAPIkey || !this.NgpVanUsername) {
                eventBus.trigger("notify", {
                    notification: {
                        group: "top-right",
                        type: "warning",
                        text: "Please provide a valid Username and API Key.",
                    },
                });
                return false;
            }
            try {
                const response = await this.$alfredService.postNgpVanAPIKey({
                    api_key: this.NgpVanAPIkey,
                    username: this.NgpVanUsername
                });
                if (response) {
                    this.callNgpVanList();
                } else {
                    eventBus.trigger("notify", {
                        notification: {
                            group: "top-right",
                            type: "warning",
                            text: "Your NGP VAN API Key is not valid",
                        },
                    });
                }
            } catch (e) {
                eventBus.trigger("notify", {
                    notification: {
                        group: "top-right",
                        type: "warning",
                        text: "Your NGP VAN API Key is not valid",
                    },
                });
                return false;
            }
        },
        async ImportNgpVan() {
            if (!this.NgpVanIdImport) {
                eventBus.trigger("notify", {
                    notification: {
                        group: "top-right",
                        type: "warning",
                        text: "Please select a list to import",
                    },
                });
                return false;
            }
            this.isLoading = true;
            let payload = {
                list_id: this.NgpVanIdImport
            }
            try {
                this.isImporting = true;
                this.progress = 0;
                this.$emit('NgpVan-clicked', true);

                this.progressTimer = setInterval(() => {
                    if (this.progress < 90) {
                        this.progress += 5;
                    }
                }, 500);

                const response = await this.$alfredService.ngpVanImport(payload);
                if (response) {
                    if (response.detail && response.detail === "List is empty") {
                        eventBus.trigger("notify", {
                            notification: {
                                group: "top-right",
                                type: "error",
                                text: "List is empty",
                            },
                        });
                        this.$emit('NgpVanImport', true);
                        eventBus.trigger("update");
                    } else {
                        eventBus.trigger("notify", {
                            notification: {
                                group: "top-right",
                                type: "success",
                                text: "NGP VAN list imported successfully",
                            },
                        });
                        this.progress = 100;
                        await new Promise(resolve => setTimeout(resolve, 500));
                        this.$emit('NgpVanImport', true);
                        eventBus.trigger("update");
                    }
                }
            } catch (e) {
                console.error(e);
                eventBus.trigger("notify", {
                        notification: {
                            group: "top-right",
                            type: "error",
                            text: "NGP VAN list import failed",
                        },
                    });
                    this.progress = 100;
                    this.$emit('NgpVanImport', true);
                    eventBus.trigger("update");
            } finally {
                clearInterval(this.progressTimer);
                this.progressTimer = null;
                this.$emit('NgpVan-clicked', false);
            }
        },
        async removeNgpVan() {
            const modal = useConfirmationModal();
            await modal.openModal({
                title: "Are you sure you want to permanently remove NGP VAN?",
                message: "This action cannot be undone.",
                onSubmit: async () => {
                    await this.removeNgpVanFunc();
                },
            });
        },
        async removeNgpVanFunc() {
            try {
                await this.$alfredService.ngpVanAPIKeyDelete();
                this.isNgpVanAccess = false;
                eventBus.trigger("notify", {
                    notification: {
                        group: "top-right",
                        type: "success",
                        text: "Successfully removed NGP VAN",
                    },
                });
            } catch (e) {
                console.log("error", e);
            }
        },
    },
    beforeUnmount() {
        clearInterval(this.progressTimer);
        this.progressTimer = null;
    },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.popup-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
}

.popup {
    background-color: white;
    padding: 20px;
    border-radius: 8px 8px 0 0;
    box-shadow: None !important;
}

.box-item {
    background-color: #f0f0f0;
    padding: 10px;
    cursor: pointer;
    position: relative;
    height: 10rem;
}

.box-item:hover {
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
}

.selected-box {
    background-color: #fee2e2;
    border: 1px solid #fd7e7e !important;
}

.box-color {
    background-color: #c9c9c9;
}

.selected-color {
    background-color: #ffc4c4 !important;
}

.used-box {
    opacity: 0.5;
    cursor: not-allowed;
}

.unselected-box {
    opacity: 0.8;
}

.checkbox {
    position: absolute;
    top: 5px;
    right: 5px;
}

.checkbox {
    position: absolute;
    top: 5px;
    right: 5px;
    appearance: none;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    border: 2px solid #ff0000;
    background-color: #ff0000;
}

.checkbox:checked {
    background-color: #ff0000;
}

[type='checkbox'],
[type='radio'] {
    color: #ff0000;
}
</style>
